import { Flex, Label, useStyles } from '@archipro-design/aria';
import { useHandleTopNavTransitions } from '@archipro-website/top-navigation';
import { useRef } from 'react';

import * as S from './TitleSection.desktop.style';
import { useBoolean } from 'ahooks';

interface TitleSectionProps {
    categoryDescription: string;
    category: string;
    itemsInCategory: number;
    rootCategory?: string;
    showCategoryTitle?: boolean;
    isRoot?: boolean;
}
const CATEGORY_DESCRIPTION =
    "Find everything you need to build, whether it's a tap or a cladding system. Connect to purchase directly from New Zealand's leading product suppliers.";

export const TitleSectionDesktop = ({
    categoryDescription,
    category,
    rootCategory,
    itemsInCategory,
    showCategoryTitle = true,
    isRoot,
}: TitleSectionProps) => {
    const filterRef = useRef<HTMLDivElement>(null);
    const filterState = useHandleTopNavTransitions(filterRef);
    const [viewAllDescription, descriptionState] = useBoolean(false);
    const { css } = useStyles({
        filterState,
        viewAllDescription,
        showCategoryTitle,
    });

    const GiantText = isRoot ? (
        <h1 className="text-62.5 font-normal -ml-5 leading-none tracking-[-0.04em] text-black inline relative">
            {rootCategory ?? category}
        </h1>
    ) : (
        <div
            aria-hidden={true}
            className="inline relative before:content-[attr(data-giant-text-content)] before:inline before:relative before:text-black before:leading-none before:tracking-[-0.04em] before:text-62.5 before:-ml-5"
            data-giant-text-content={rootCategory ?? category}
        />
    );

    return (
        <div className={css(S.PageTopSectionWrapper)}>
            <Flex space="between" className={css(S.PageTopSection)}>
                {showCategoryTitle && (
                    <div className={css(S.TitleWrapper)}>
                        {GiantText}
                        <div className="absolute m-2 align-top text-black text-lg inline-flex flex-col-reverse w-70">
                            {!isRoot && (
                                <h1 className="inline-block text-lg m-0">
                                    {category}
                                </h1>
                            )}
                            <div className="text-lg">
                                {itemsInCategory?.toLocaleString()}
                            </div>
                        </div>
                    </div>
                )}
                <div className={css(S.CategoryDescriptionWrapper)}>
                    <Label
                        variant="02"
                        maximumLines={viewAllDescription ? 0 : 6}
                        dangerouslySetInnerHTML={{
                            __html:
                                `<p>${categoryDescription}</p>` ||
                                CATEGORY_DESCRIPTION,
                        }}
                        onClick={() => descriptionState.setTrue()}
                    />
                </div>
            </Flex>
        </div>
    );
};
